export const PARENT_MATCH = 'match';
export const PARENT_TRAINING = 'training';
export const PARENT_HIGHLIGHT = 'highlight';
export const PARENT_OTHER = 'other';
export const PARENT_COMPETITION = 'competition';

export const CHILD_MATCH_FRIENDLY = 'friendly';
export const CHILD_MATCH_CUP = 'cup';
export const CHILD_MATCH_LEAGUE = 'league';
export const CHILD_MATCH_LEAGUE_ID = 3;

export const CHILD_TRAINING_MATCH = 'match';
export const CHILD_TRAINING_TACTICS = 'tactics';
export const CHILD_TRAINING_FREEPRACTICE = 'freepractice';
export const CHILD_TRAINING_HALFCOURTS = 'halfcourts';
